import React, { useEffect, useRef, useState } from "react";
import TopLeftUserName from "../components/TopLeftUserName";
import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonImg,
  IonInput,
  IonModal,
  IonPage,
  IonRow,
} from "@ionic/react";
import PYLogo from "../assets/images/PY-logo.png";
import {
  allExercisesState,
  duplicateExercisePlanState,
  networkConnectionStatus,
  PatientState,
} from "../data/atoms";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  GenerateExercisePlanPdf,
  GetAssignedExercisesData,
  SaveEmailStatusAndReportUrl,
  SavePatientEmail,
  SavePdfUrlAgainstPatient,
  SaveRecommendedExercises,
} from "../services/ExercisesService";
import { useHistory } from "react-router";
import { ActionType } from "../models/Enums";
import SuccessModal from "../components/modals/success-modal";
import {
  getPatientIntegrationLock,
  localDateTime,
} from "../utils/sharedFunction";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ProactiveYouModal from "../components/modals/ProactiveYouModal";
import { PatientVM } from "../models/PatientVM";
import CompletedEducationModal from "../components/modals/completed-education-modal";
import { printPdfForMobile } from "../utils/mobile-bridge";
import PatientRegistrationQRModal from "../components/modals/patient-registeration-qr-modal";
import { GetRtmPatientEducationStatus } from "../services/AuthServices";
import ErrorTopToaster from "../components/ErrorTopToaster";

const SendExercisePlan = () => {
  let history = useHistory();
  const allExercises = useRecoilValue(allExercisesState);
  const previousExercise = useRecoilValue(duplicateExercisePlanState);
  const [errorMessage, setErrorMessage] = useState("");
  // const previousExercise = useRecoilValue(newDuplicateExercisePlanState);
  const [isValid, setIsValid] = useState(true);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [reportData, setReportData] = useState<any>([]);
  const [sendingModal, setSendingModal] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const [proactiveYouModal, setProactiveYouModal] = useState<boolean>(false);
  const [dummyImage, setDummyImage] = useState<any>();
  const [patientEmail, setEmail] = useState<any>({
    email: allExercises.patientDetails[0].email,
  });
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );
  const [pdfBase64, setPdfBase64] = useState<string | null>(null);
  const emailRegex = /^[\w+,]+(?:[.-][\w+,]+)*@\w+(?:[.-]\w+)*\.\w{2,3}$/i;
  const [isRtmConfigurationEnabled, setIsRtmConfigurationEnabled] =
    useState(false);
  const rtmEnabledRef = useRef(false);
  const [CompletedEducation, setCompletedEducation] = useState(false);
  const [registerPatientModal, setRegisterPatientModal] = useState(false);

  useEffect(() => {
    const rtmEnabled = localStorage.getItem("isRtmEnabled") === "true";
    setIsRtmConfigurationEnabled(rtmEnabled);
    rtmEnabledRef.current = rtmEnabled;
  }, []);

  console.log("allExercises patient details", allExercises.patientDetails);
  const validateEmail = (email: string) => {
    setIsDuplicate(false);
    if (email === "") {
      return false;
    } else if (emailRegex.test(email)) {
      return true;
    } else return false;
  };

  const [patientDetailsRecoil, setPatientDetailsRecoil] =
    useRecoilState(PatientState);

  const [patientDetails, setPatientDetails] =
    useState<PatientVM>(patientDetailsRecoil);
  const patientIntegrationLock = getPatientIntegrationLock(
    patientDetailsRecoil
  );

  const handleRegisterPatient = () => {
    debugger;
    console.log("Register Patient clicked");
    setProactiveYouModal(false);
    setRegisterPatientModal(true);
  };

  const handleCloseRegistrationModal = async () => {
    setRegisterPatientModal(false);
    // Refresh patient details to get updated RTM status
    // await GetPatientVisitDetails();
  };

  const onSubmit = async (e: React.FormEvent) => {
    debugger;
    e.preventDefault();
    setIsSubmitted(true);
    let emailValidity = validateEmail(patientEmail.email);
    setIsValid(emailValidity);

    if (!emailValidity) return;

    setSendingModal(true);
    if (
      emailValidity &&
      patientEmail.email !== allExercises.patientDetails[0].email
    ) {
      // save email
      if (!navigator.onLine) {
        setShowNetWorkRecoil({ isShown: true });
        return;
      }

      try {
        let response = await SavePatientEmail({
          patientId: +localStorage.getItem("patientServerID")!,
          email: patientEmail.email,
        });
        if (response?.data.errorMessage === "Email already exists") {
          setIsDuplicate(true);
          setSendingModal(false);
          return;
        } else {
          setPatientDetails((prevState: PatientVM) => ({
            ...prevState,
            email: patientEmail.email,
          }));
          setPatientDetailsRecoil((prevState: PatientVM) => ({
            ...prevState,
            email: patientEmail.email,
          }));
        }
      } catch (error) {
        setSendingModal(false);
        history.push("/confirmation", {
          actionType: ActionType.FailureAPIResponse,
        });
        console.error(error);
      }
    }
    await saveExercises();
  };

  const saveExercises = async () => {
    const exerciseDetails: any[] = previousExercise.exercises.map(
      (item: any) => ({
        ExerciseId: item.testExercises[0].id,
        VBTestLookupId: item.testExercises[0].vbTestLookupId,
        MobilityLevelId: item.testExercises[0].mobilityLevelId,
        NoOfSets: item.testExercises[0].noOfSets,
        NoOfDays: item.testExercises[0].noOfDays,
        NoOfTimes: item.testExercises[0].noOfTimes,
        RepsOrDuration: item.testExercises[0].repsOrDuration,
        RepsOrDurationUnits: item.testExercises[0].repsOrDurationUnits,
        FrequencyId: item.testExercises[0].frequencyId,
        NoOfWeeks: item.testExercises[0].noOfWeeks,
        RepsId:
          item.testExercises[0].repsId == null
            ? 0
            : item.testExercises[0].repsId,
        Hold: item.testExercises[0].hold,
        Weight: item.testExercises[0].weight,
        PatientId: +localStorage.getItem("patientServerID")!,
        LocalDateTimeString: localDateTime(),
      }),
    );
    try {
      await SaveRecommendedExercises({
        exerciseDetails,
      })
        .then(async function (response: any) {
          debugger;
          console.log("exercises", response.data);
          // await getAssignedExercisesReportData(response.data.visitId);
          await generateExercisePlanPdf(response);
        })
        .catch((error) => {
          setSendingModal(false);
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
          console.error(error);
        });
    } catch (error) {
      setSendingModal(false);
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };

  const getAssignedExercisesReportData = async (visitId: number) => {
    try {
      await GetAssignedExercisesData({
        patientId: +localStorage.getItem("patientServerID")!,
        visitId: visitId,
        recommendationDate: localDateTime(),
        therapistId: +localStorage.getItem("therapistServerID")!,
        LocalDateTime: localDateTime(),
      })
        .then(async function (response: any) {
          debugger;
          console.log("exercises", response.data);
          setReportData(response.data);
          setTimeout(() => {
            generateHtmlPdf(visitId);
          }, 5000);
        })
        .catch((error) => {
          setSendingModal(false);
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
          console.error(error);
        });
    } catch (error) {
      setSendingModal(false);
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };

  const savePdfUrlAgainstPatient = async (
    saveExerciseResponse: any,
    pdfLink: string,
    isSaveCall: boolean = true,
  ) => {
    try {
      await SavePdfUrlAgainstPatient({
        patientId: +localStorage.getItem("patientServerID")!,
        pdfUrl: pdfLink,
        masterRecommendationId:
          saveExerciseResponse.data.masterRecommendationId,
        therapistId: +localStorage.getItem("therapistServerID")!,
        LocalDateTime: localDateTime(),
      })
        .then(async function (responseSavePdf: any) {
          console.log("response", responseSavePdf);
          if (isSaveCall) {
            // setSavingModal(false);
            // if (
            //   saveExerciseResponse.data.masterRecommendationId !== 0 &&
            //   saveExerciseResponse.data.visitId !== 0
            // ) {
            //   if (
            //     rtmEnabledRef.current &&
            //     patientDetails.isPatientRTMEnabled &&
            //     !patientDetails?.isEverEducated
            //   ) {
            //     setCompletedEducation(true);
            //   } else {
            //     setSuccessModal(true);
            //   }
            // }
          } else {
            sendEmail(pdfLink, saveExerciseResponse.data.visitId);
          }
        })
        .catch((error) => {
          setSendingModal(false);
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
          console.error(error);
        });
    } catch (error) {
      setSendingModal(false);
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };

  const generateExercisePlanPdf = async (saveResponse: any) => {
    try {
      await GenerateExercisePlanPdf({
        patientId: +localStorage.getItem("patientServerID")!,
        MasterPatientId: +localStorage.getItem("patientMasterID")!,
        visitId: saveResponse?.data?.visitId,
        recommendationDate: localDateTime(),
        therapistId: +localStorage.getItem("therapistServerID")!,
        LocalDateTime: localDateTime(),
        EncryptedSystemId: localStorage.getItem("EncryptedSystemId"),
      })
        .then(async function (response: any) {
          await savePdfUrlAgainstPatient(saveResponse, response.data, false);
          // sendEmail(response.data, visitId);
        })
        .catch((error) => {
          setSendingModal(false);
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
          console.error(error);
        });
    } catch (error) {
      setSendingModal(false);
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };

  const dismissSendingModal = async (boolean: boolean) => {
    setSendingModal(false);
  };

  const dismissSuccessModal = async (boolean: boolean) => {
    setSuccessModal(false);
  };

  const showProactiveModal = async () => {
    setSuccessModal(false);
    setProactiveYouModal(true);
  };

  const generateHtmlPdf = async (visitId: number) => {
    debugger;
    const pdf = new jsPDF();
    let getHtmlContent = document.getElementById(
      "reportContent",
    ) as HTMLElement;
    console.log("getHtmlContent", getHtmlContent);
    const reports = document.querySelectorAll(".pdfContent");
    // pdf.html(getHtmlContent, {
    //   callback: function (doc) {
    //     // This function is called once the PDF is generated
    //     //  const pdfBase64 = doc.output("datauristring");
    //     doc.save("exercise-plan.pdf");
    //     //setPdfBase64(pdfBase64);
    //     // sendEmail(pdfBase64, visitId);
    //   },
    //   x: 10,
    //   y: 10,
    // });
    // pdf.addPage();
    // return pdf;
    // let content = document.getElementById("testRowsHolder")?.firstChild;
    // if (content != undefined) {
    let pdfBase64 = "";
    console.log("reportsContent", reports);

    const footerCanvas = await html2canvas(
      document.getElementById("footer") as HTMLElement,
    );

    const footerImgData = footerCanvas.toDataURL("image/png");
    reports.forEach(async (element, index) => {
      if (element !== undefined) {
        await html2canvas(element as HTMLElement).then((canvas) => {
          debugger;
          const imgData = canvas.toDataURL("image/jpeg");
          const imgWidth = 210; // A4 width in mm
          const pageHeight = 295; // A4 height in mm
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          let heightLeft = imgHeight;

          let position = 10;

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            if (index > 0) pdf.addPage();
            pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);

            heightLeft -= pageHeight;
          }

          if (reports.length - 1 === index) {
            addFooters(pdf, footerCanvas, footerImgData);
            pdfBase64 = pdf.output("datauristring");
            setPdfBase64(pdfBase64);
            sendEmail(pdfBase64, visitId);
            //pdf.save("sample.pdf");
            return pdf;
          }
        });
      }
    });
  };

  const addFooters = (pdf: any, footerCanvas: any, footerImgData: any) => {
    // Add page number

    const pageCount = pdf.internal.getNumberOfPages();
    const footerText = "Page ";

    // pdf.setFont("helvetica");
    pdf.setFontSize(5);

    for (var i = 1; i <= pageCount; i++) {
      pdf.setPage(i);
      // const footerHeight = 100; // Adjust height of footer as needed
      const x =
        (pdf.internal.pageSize.getWidth() -
          (footerCanvas.width * 240) / footerCanvas.width) /
        2;
      const y = pdf.internal.pageSize.getHeight() - 30;
      pdf.addImage(footerImgData, "JPEG", 10, y, 190, 0);

      pdf.setFontSize(10);

      const textWidth =
        (pdf.getStringUnitWidth(`${footerText} ${i} / ${pageCount}`) *
          pdf.internal.getFontSize()) /
        pdf.internal.scaleFactor;
      pdf.text(
        `${footerText} ${i} / ${pageCount}`,
        (pdf.internal.pageSize.getWidth() - textWidth) / 2,
        pdf.internal.pageSize.getHeight() - 10,
      ); // Add footer at the bottom
    }
  };

  const sendEmail = async (base64: string, visitId: number) => {
    try {
      debugger;
      await SaveEmailStatusAndReportUrl({
        patientId: +localStorage.getItem("patientServerID")!,
        patientEmailAddress: patientEmail.email,
        patientName: localStorage.getItem("patientName")!,
        PatientMobilePhone: localStorage.getItem("patientMobileNumber")!,
        fileBase64string: base64,
        visitId: visitId,
        localDateTimeString: localDateTime(), //new Date().toLocaleDateString(),
        therapistId: +localStorage.getItem("therapistServerID")!,
        IsPatientRtmEnabled: patientDetails.isPatientRTMEnabled,
      })
        .then(async function (response: any) {
          debugger;
          console.log("exercises", response.data);
          setSendingModal(false);

          // setSuccessModal(true);
          //Skip education modal for select business only
          const isSFTPPatient =
            localStorage.getItem("isSFTPPatient") === "true" ? true : false;
          if (
            rtmEnabledRef.current &&
            patientDetails.isPatientRTMEnabled &&
            !isSFTPPatient &&
            false
          ) {
            try {
              const response: any = await GetRtmPatientEducationStatus({
                PatientId: localStorage.getItem("patientServerID"),
                EncryptedServerId: localStorage.getItem("EncryptedServerId"),
              });

              console.log("response", response);

              if (!response?.data) {
                setCompletedEducation(true);
              } else {
                setSuccessModal(true);
              }
            } catch (error) {
              history.push("/confirmation", {
                actionType: ActionType.FailureAPIResponse,
              });
              console.error(error);
            }
          } else {
            setSuccessModal(true);
          }

          // if (
          //   rtmEnabledRef.current &&
          //   patientDetails.isPatientRTMEnabled &&
          //   !patientDetails?.isEverEducated
          // ) {
          //   setCompletedEducation(true);
          // } else {
          //   setSuccessModal(true);
          // }
        })
        .catch((error) => {
          setSendingModal(false);
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
          console.error(error);
        });
    } catch (error) {
      setSendingModal(false);
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };

  const HideProactiveModal = async () => {
    setProactiveYouModal(false);
  };

  const goBack = async () => {
    history.goBack();
  };

  useEffect(() => {
    setEmail({ email: allExercises.patientDetails[0].email });
    setIsDuplicate(false);
    setIsSubmitted(false);
  }, [allExercises]);

  // Clear error message after 5 seconds
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const handleEducationClose = () => {
    setCompletedEducation(false);
    setSuccessModal(true);
  };

  return (
    <>
      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={CompletedEducation}
        placeholder={undefined}
      >
        <CompletedEducationModal
          setCompletedEducation={setCompletedEducation}
          patientName={
            patientDetails?.firstName + " " + patientDetails?.lastName
          }
          onClose={handleEducationClose}
        ></CompletedEducationModal>
      </IonModal>

      <IonModal
        className="all-generic-new-modal-center-main-wrap"
        backdropDismiss={false}
        isOpen={successModal}
        placeholder={undefined}
      >
        <SuccessModal
          setShowModal={dismissSuccessModal}
          showProactiveModal={showProactiveModal}
          actionType={ActionType.SuccessExercisePlanSent}
        ></SuccessModal>
      </IonModal>

      <IonModal
        className="all-generic-new-modal-center-main-wrap"
        backdropDismiss={false}
        isOpen={sendingModal}
        placeholder={undefined}
      >
        <SuccessModal
          setShowModal={dismissSendingModal}
          showProactiveModal={showProactiveModal}
          actionType={ActionType.LoadSending}
        ></SuccessModal>
      </IonModal>
      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={proactiveYouModal}
        placeholder={undefined}
      >
        <ProactiveYouModal
          HideProactiveModal={HideProactiveModal}
          onRegisterPatient={handleRegisterPatient}
        ></ProactiveYouModal>
      </IonModal>
      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={registerPatientModal}
        placeholder={undefined}
      >
        <PatientRegistrationQRModal
          setRegisterPatientModal={handleCloseRegistrationModal}
          patientData={{
            masterPatientId: Number(localStorage.getItem("masterUserId")) || 0,
            email: patientDetails?.email,
            mobilePhone: patientDetails?.mobilePhone,
            firstName: patientDetails?.firstName,
            lastName: patientDetails?.lastName,
            fullName:
              patientDetails?.firstName + " " + patientDetails?.lastName,
            patientName:
              patientDetails?.firstName + " " + patientDetails?.lastName,
            dob: patientDetails?.dob,
            DOB: patientDetails?.dob,
            FirstName: patientDetails?.firstName,
            LastName: patientDetails?.lastName,
            PatientLocationId: patientDetails?.patientLocationId,
          }}
          isCalledAfterRtmEnabled={true}
          onError={(message) => {
            setErrorMessage(message);
          }}
        />
      </IonModal>
      <IonPage placeholder={undefined}>
        <IonHeader className="ion-no-border" placeholder={undefined}>
          <TopLeftUserName headerText={"Send Exercise Plan"}></TopLeftUserName>
        </IonHeader>
        <IonContent placeholder={undefined} className="slide-in-right">
          <div className="send-exercise-plan-main-wrap">
            <IonGrid className="container" placeholder={undefined}>
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  {errorMessage && (
                    <ErrorTopToaster errorString={errorMessage} />
                  )}

                  <div className="send-exercise-plan-wrap">
                    <IonImg
                      src={PYLogo}
                      alt="logo"
                      placeholder={undefined}
                    ></IonImg>
                    <h3>Sent to ProactiveYou</h3>
                    <p>
                      This exercise plan will be sent to the patient's email and
                      ProactiveYou account.
                    </p>
                    <form
                      className={` ${!isValid || isDuplicate ? "error" : ""}`}
                      onSubmit={onSubmit}
                    >
                      <label>Email*</label>
                      <IonInput
                        type="email"
                        placeholder="email@example.com"
                        value={patientEmail.email}
                        disabled={patientIntegrationLock.disableIntegrationOnlyFields}
                        className="ex-plan-input"
                        onIonChange={(e) =>
                          setEmail({ ["email"]: e.target.value })
                        }
                      ></IonInput>
                      {!isValid && (
                        <div className="error-tooltip-msg">
                          <p>Please enter a valid email.</p>
                        </div>
                      )}
                      {isSubmitted && isDuplicate && (
                        <div className="error-tooltip-msg">
                          <p>Email already exists.</p>
                        </div>
                      )}
                    </form>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </div>
        </IonContent>
        <IonFooter
          className="ion-no-border duplicate-ex-page-footer"
          placeholder={undefined}
        >
          <IonGrid className="container" placeholder={undefined}>
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="two-col-btn">
                  <IonButton
                    placeholder={undefined}
                    className="blue-outline-btn"
                    onClick={goBack}
                  >
                    Cancel
                  </IonButton>
                  <IonButton
                    placeholder={undefined}
                    className="blue-btn"
                    onClick={onSubmit}
                  >
                    Send
                  </IonButton>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonFooter>
        <div
          style={{
            position: "fixed",
            zIndex: -1,
            width: "21cm",
            opacity: "0",
            top: "-100px",
          }}
        >
          <div
            style={{
              pageBreakAfter: "always",
            }}
            id="reportContent"
          >
            <div id="testRowsHolder2">
              {reportData &&
                reportData?.map((exercise: any) => {
                  return (
                    <div
                      className="pdfContent"
                      key={exercise.id}
                      style={{
                        backgroundColor: "#fff",
                        padding: "40px 30px",

                        // width: "100%",
                        // margin: "0 auto",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          borderBottom: "5px solid #F8993A",
                          paddingBottom: "10px",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ width: "33.33%" }}>
                          <h2
                            style={{
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18px",
                              textAlign: "left",
                              color: "#000000",
                              margin: "0px",
                              textTransform: "uppercase",
                            }}
                          >
                            {exercise.patientName}
                          </h2>
                          <span
                            style={{
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18px",
                              textAlign: "left",
                              color: "#000000",
                              margin: "0px",
                              display: "block",
                            }}
                          >
                            Assigned Date: {exercise.dateRecommendedToShow}
                          </span>
                          <span
                            style={{
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18px",
                              textAlign: "left",
                              color: "#000000",
                              margin: "0px",
                              display: "block",
                            }}
                          >
                            Assigned By: {exercise.therapistName}
                          </span>
                        </div>
                        <div style={{ width: "33.33%", textAlign: "center" }}>
                          <img
                            style={{ width: "200px" }}
                            alt="Logo"
                            src="data:image/png;base64,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"
                          />
                        </div>
                        <div style={{ width: "33.33%", textAlign: "right" }}>
                          <img
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAABLCAIAAACz2T2AAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABlSURBVHhe7c8BDQAwEMSg+Td908GnOODtrm6mbqZupm6mbqZupm6mbqZupm6mbqZupm6mbqZupm6mbqZupm6mbqZupm6mbqZupm6mbqZupm6mbqZupm6mbqZupm6mbqZupm6i7QOV/OyJj1aiWAAAAABJRU5ErkJggg=="
                            alt="img"
                          />
                        </div>
                      </div>
                      <div className="inner-page-main-wrap-sec">
                        <div
                          style={{
                            textAlign: "center",
                            margin: "22px 10px 10px 10px",
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "700",
                              fontStyle: "nomal",
                              fontSize: "24px",
                              lineHeight: "28px",
                              textAlign: "center",
                              color: "#000",
                              marginTop: "20px",
                            }}
                          >
                            {exercise.exerciseName}
                          </h3>
                        </div>
                        <div className="exercise-plan-sec">
                          <table
                            style={{
                              width: "100%",
                              textAlign: "center",
                              marginTop: "20px",
                            }}
                          >
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    background: "#F3F3F3",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  Sets (#)
                                </th>
                                <th
                                  style={{
                                    background: "#F3F3F3",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  Reps (#)
                                </th>
                                <th
                                  style={{
                                    background: "#F3F3F3",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  Times per Day
                                </th>
                                <th
                                  style={{
                                    background: "#F3F3F3",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  Days per Week
                                </th>
                                <th
                                  style={{
                                    background: "#F3F3F3",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  Hold (seconds)
                                </th>
                                <th
                                  style={{
                                    background: "#F3F3F3",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  Weight (lbs)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    background: "#fff",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  {exercise.noOfSets}
                                </td>
                                <td
                                  style={{
                                    background: "#fff",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  {exercise.repsOrDuration}
                                  {exercise.repsOrDurationUnits}
                                  {exercise.sideName
                                    ? `(${exercise.sideName})`
                                    : ""}
                                </td>
                                <td
                                  style={{
                                    background: "#fff",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  {exercise.noOfTimes}
                                </td>
                                <td
                                  style={{
                                    background: "#fff",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  {exercise.noOfDays}
                                </td>
                                <td
                                  style={{
                                    background: "#fff",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  {exercise.hold}
                                </td>
                                <td
                                  style={{
                                    background: "#fff",
                                    fontWeight: "700",
                                    border: "1px solid #000",
                                    padding: "5px",
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "#1A1040",
                                  }}
                                >
                                  {exercise.weight}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "100px",
                            maxWidth: "400px",
                            margin: "30px auto",
                            width: "100%",
                          }}
                        >
                          {exercise.exerciseSteps.map((steps: any) => {
                            return (
                              <div>
                                <img
                                  src={`${steps.imagePath}`}
                                  alt="img"
                                  style={{ width: "50%" }}
                                />
                              </div>
                            );
                          })}
                        </div>

                        <div style={{ marginBottom: "20px" }}>
                          <h3
                            style={{
                              fontStyle: "normal",
                              fontWeight: "900",
                              fontSize: "18px",
                              lineHeight: "22px",
                              color: "#000",
                              marginBottom: "10px",
                            }}
                          >
                            Setup:
                          </h3>
                          {exercise.exerciseSteps.map((steps: any) => {
                            if (steps.setup != null)
                              return steps.setup.map((setup: any) => {
                                return (
                                  <p
                                    style={{
                                      textAlign: "left",
                                      fontStyle: "normal",
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      color: "#000000",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    {setup}
                                  </p>
                                );
                              });
                          })}
                        </div>

                        <div style={{ marginBottom: "20px" }}>
                          <h3
                            style={{
                              fontStyle: "normal",
                              fontWeight: "900",
                              fontSize: "18px",
                              lineHeight: "22px",
                              color: "#000",
                              marginBottom: "10px",
                            }}
                          >
                            Instructions:
                          </h3>
                          {exercise.exerciseSteps.map((steps: any) => {
                            if (steps.instructions != null) {
                              return (
                                <ol
                                  style={{
                                    marginLeft: "30px",
                                    padding: "0px",
                                    // listStyleType: "none",
                                  }}
                                >
                                  {steps.instructions.map(
                                    (instruction: any) => {
                                      return (
                                        <li
                                          style={{
                                            // listStyleType: "none",
                                            fontStyle: "normal",
                                            fontWeight: "400",
                                            fontSize: "14px",
                                            color: "#000000",
                                            marginBottom: "5px",
                                          }}
                                        >
                                          {instruction}
                                        </li>
                                      );
                                    },
                                  )}
                                </ol>
                              );
                            }
                          })}
                        </div>

                        <div style={{ marginBottom: "20px" }}>
                          <h3
                            style={{
                              fontStyle: "normal",
                              fontWeight: "900",
                              fontSize: "18px",
                              lineHeight: "22px",
                              color: "#000",
                              marginBottom: "10px",
                            }}
                          >
                            Form Check:
                          </h3>
                          {exercise.exerciseSteps.map((steps: any) => {
                            if (steps.formCheck != null) {
                              return (
                                <ul
                                  style={{
                                    marginLeft: "30px",
                                    padding: "0px",
                                    listStyleType: "disx",
                                  }}
                                >
                                  {steps.formCheck.map((formCheck: any) => {
                                    return (
                                      <li
                                        style={{
                                          listStyleType: "disc",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          fontSize: "14px",
                                          color: "#000000",
                                          marginBottom: "5px",
                                        }}
                                      >
                                        {formCheck}
                                      </li>
                                    );
                                  })}
                                </ul>
                              );
                            }
                          })}
                        </div>
                      </div>

                      <img
                        src={dummyImage}
                        style={{ display: "none" }}
                        id="dummyImageLink"
                      />
                    </div>
                  );
                })}
            </div>
          </div>
          <div
            id="zindex"
            style={{
              position: "fixed",
              zIndex: -1,
              top: "-100px",
              width: "21cm",
            }}
          >
            <div
              id="footer"
              style={{
                marginTop: "15px",
                borderTop: "5px solid #F8993A",
                paddingTop: "10px",
                width: "100%",
              }}
            >
              <p
                style={{
                  textAlign: "center",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "18px",
                  color: "#000",
                  margin: "15px 0px",
                }}
              >
                *Stop immediately if you experience pain or discomfort and
                contact the clinician who referred the exercise program.
              </p>
            </div>
          </div>
        </div>
      </IonPage>
    </>
  );
};

export default SendExercisePlan;
